import { Colors, FontSize } from '../../styles'
import styled from 'styled-components'
import { Button } from '../../components'

export const Main = styled.main`
  padding: 24px;
  overflow: none;
  width: 100%;
  height: 100%;
`

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  vertical-align: center;
  justify-content: space-around;
`

export const StatusCell = styled.div`
  width: 100%;
  display: flex;
  cursor: ${(p) => p.cursor};
  padding: 0px 5px;
  border-radius: 5px;
  justify-content: center;
  color: ${(p) => p.color};
  background-color: ${(p) => p.backgroundColor};
  border: solid ${(p) => (p.backgroundColor === Colors.white ? '1px' : '0px')} ${Colors.darkSlate};
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`

export const HeaderVesselForecast = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 48px;
  justify-content: space-between;
`
export const Title = styled.h1`
  margin: 0;
  font-weight: 600;
  text-transform: uppercase;
  font-size: ${FontSize.extraExtraLarge}px;
`
export const ActionWrapper = styled.div`
  gap: 16px;
  display: flex;
  vertical-align: center;
`
export const DropdownContainer = styled.div`
  width: 50%;
  position: relative;
  display: flex;
  justify-content: flex-end;
`
export const ButtonAdd = styled(Button)`
  width: 200px;
`
export const VesselForecastFilter = styled.div`
  display: flex;
  gap: 32px;
  margin-top: 8px;
  margin-bottom: 8px;
  justify-content: start;
`
export const FilterItem = styled.span`
  font-weight: 500;
  font-size: 16px;
`

const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const LegendContainer = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  justify-content: flex-start;
`

const LegendItem = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const LegendLabel = styled.div`
  gap: 8px;
  margin: 0;
  color: ${Colors.softBlack};
  display: flex;
  font-size: 12px;
  font-weight: 400;
  align-items: center;
`

const LegendColor = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(p) => p.color};
`

export default {
  Main,
  Title,
  ButtonAdd,
  FilterItem,
  StatusCell,
  LegendItem,
  LegendLabel,
  LegendColor,
  ActionWrapper,
  GridContainer,
  LegendContainer,
  ActionContainer,
  LoadingContainer,
  DropdownContainer,
  HeaderVesselForecast,
  VesselForecastFilter,
}